import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = '/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('ebd_token');

  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const isExpired = payload.exp * 1000 < Date.now();

      if (isExpired) {
        localStorage.removeItem('ebd_token');
        localStorage.removeItem('ebd_user');
        localStorage.removeItem('last_data_update');
        window.location.reload();
        return {
          'Content-Type': 'application/json'
        };
      }
    } catch (error) {
      localStorage.removeItem('ebd_token');
      localStorage.removeItem('ebd_user');
      localStorage.removeItem('last_data_update');
      window.location.reload();
      return {
        'Content-Type': 'application/json'
      };
    }
  }

  return token ? {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  } : {
    'Content-Type': 'application/json'
  };
};

export const Usuarios = ({ setCurrentView, currentUser, turmas }) => {
  const [usuarios, setUsuarios] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    senha: '',
    tipo: 'professor',
    turmas_permitidas: []
  });

  useEffect(() => {
    loadUsuarios();
  }, []);

  const loadUsuarios = async () => {
    try {
      const response = await axios.get(`${API}/users`, { headers: getAuthHeaders() });
      setUsuarios(response.data);
    } catch (error) {
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingUser) {
        const updateData = {
          nome: formData.nome,
          email: formData.email,
          tipo: formData.tipo,
          turmas_permitidas: formData.turmas_permitidas
        };

        if (formData.senha.trim()) {
          updateData.senha = formData.senha;
        }

        await axios.put(`${API}/users/${editingUser}`, updateData, {
          headers: getAuthHeaders()
        });
        alert('Usuário atualizado com sucesso!');
      } else {
        await axios.post(`${API}/users`, formData, {
          headers: getAuthHeaders()
        });
        alert('Usuário criado com sucesso!');
      }

      setTimeout(() => loadUsuarios(true), 300);
      setShowForm(false);
      setEditingUser(null);
      setFormData({ nome: '', email: '', senha: '', tipo: 'professor', turmas_permitidas: [] });
    } catch (error) {
      if (error.response?.data?.detail) {
        alert(`Erro: ${error.response.data.detail}`);
      } else {
        alert(`Erro ao ${editingUser ? 'atualizar' : 'criar'} usuário`);
      }
    }
  };

  const handleEdit = (usuario) => {
    setEditingUser(usuario.id);
    setFormData({
      nome: usuario.nome,
      email: usuario.email,
      senha: '',
      tipo: usuario.tipo,
      turmas_permitidas: usuario.turmas_permitidas || []
    });
    setShowForm(true);
  };

  const handleDelete = async (userId) => {
    const usuario = usuarios.find(u => u.id === userId);
    const nomeUsuario = usuario ? usuario.nome : 'usuário';

    if (window.confirm(`Tem certeza que deseja remover ${nomeUsuario}? Esta ação não pode ser desfeita.`)) {
      try {
        const response = await axios.delete(`${API}/users/${userId}`, {
          headers: getAuthHeaders()
        });
        setTimeout(() => loadUsuarios(true), 300);
        alert(`✅ ${nomeUsuario} foi removido com sucesso!`);
      } catch (error) {
        if (error.response) {
          alert(`❌ Erro ao remover usuário: ${error.response.data.detail || error.response.status}`);
        } else if (error.request) {
          alert('❌ Erro de conexão ao remover usuário');
        } else {
          alert(`❌ Erro ao remover usuário: ${error.message}`);
        }
      }
    }
  };

  const toggleTurmaPermissao = (turmaId) => {
    setFormData(prev => ({
      ...prev,
      turmas_permitidas: prev.turmas_permitidas.includes(turmaId)
        ? prev.turmas_permitidas.filter(id => id !== turmaId)
        : [...prev.turmas_permitidas, turmaId]
    }));
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <button
            onClick={() => setCurrentView('dashboard')}
            className="mb-4 px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500"
          >
            ← Voltar ao Dashboard
          </button>
          <div className="flex justify-between items-center">
            <h1 className="text-3xl font-bold text-gray-800">Gerenciar Usuários</h1>
            <button
              onClick={() => setShowForm(true)}
              className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Novo Usuário
            </button>
          </div>
        </div>

        {currentUser?.tipo === 'visitante' && (
          <div className="mb-6 p-4 bg-yellow-100 border border-yellow-400 rounded-lg">
            <div className="flex items-center">
              <span className="text-yellow-800 text-lg font-semibold">
                ⚠️ MODO DEMONSTRAÇÃO: Apenas Visualização
              </span>
            </div>
          </div>
        )}

        {showForm && (
          <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              {editingUser ? 'Editar Usuário' : 'Novo Usuário'}
            </h2>
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nome</label>
                  <input
                    type="text"
                    value={formData.nome}
                    onChange={(e) => setFormData({...formData, nome: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                  <input
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Senha {editingUser && <span className="text-sm text-gray-500">(deixe vazio para manter atual)</span>}
                  </label>
                  <input
                    type="password"
                    value={formData.senha}
                    onChange={(e) => setFormData({...formData, senha: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required={!editingUser}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Tipo</label>
                  <select
                    value={formData.tipo}
                    onChange={(e) => setFormData({...formData, tipo: e.target.value})}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="professor">Professor</option>
                    <option value="moderador">Moderador</option>
                    <option value="admin">Administrador</option>
                    <option value="visitante">Demonstração</option>
                  </select>
                </div>
              </div>

              {formData.tipo === 'professor' && (
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Turmas Permitidas</label>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-2 p-4 border rounded-lg bg-gray-50">
                    {turmas.map(turma => (
                      <label key={turma.id} className="flex items-center">
                        <input
                          type="checkbox"
                          checked={formData.turmas_permitidas.includes(turma.id)}
                          onChange={() => toggleTurmaPermissao(turma.id)}
                          className="mr-2"
                        />
                        <span className="text-sm">{turma.nome}</span>
                      </label>
                    ))}
                  </div>
                </div>
              )}

              <div className="flex space-x-4">
                <button
                  type="submit"
                  className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
                >
                  {editingUser ? 'Atualizar Usuário' : 'Criar Usuário'}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setShowForm(false);
                    setEditingUser(null);
                    setFormData({ nome: '', email: '', senha: '', tipo: 'professor', turmas_permitidas: [] });
                  }}
                  className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        )}

        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Lista de Usuários</h2>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-200">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 px-4 py-2 text-left">Nome</th>
                  <th className="border border-gray-300 px-4 py-2 text-left">Email</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Tipo</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Turmas</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Ações</th>
                </tr>
              </thead>
              <tbody>
                {usuarios.map((usuario) => (
                  <tr key={usuario.id} className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-4 py-2">{usuario.nome}</td>
                    <td className="border border-gray-300 px-4 py-2">{usuario.email}</td>
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      <span className={`px-2 py-1 rounded text-xs ${
                        usuario.tipo === 'admin'
                          ? 'bg-red-100 text-red-800'
                          : 'bg-blue-100 text-blue-800'
                      }`}>
                        {usuario.tipo === 'admin' ? 'Administrador' : usuario.tipo === 'moderador' ? 'Moderador' : 'Professor'}
                      </span>
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      {usuario.tipo === 'admin' ? (
                        <span className="text-green-600 font-semibold">Todas</span>
                      ) : (
                        <span className="text-sm">
                          {usuario.turmas_permitidas.length} turma(s)
                        </span>
                      )}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      <div className="flex justify-center space-x-2">
                        <button
                          onClick={() => handleEdit(usuario)}
                          className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 text-sm"
                        >
                          Editar
                        </button>
                        {usuario.email !== 'admin@ebd.com' && (
                          <button
                            onClick={() => handleDelete(usuario.id)}
                            className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 text-sm"
                          >
                            Remover
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
